export const menuItems_0 = [
    {
        id: 1,
        label: "menuitems.comercial.text",
        isTitle: true,
        nivel: 0,
    },

    {
        id: 800,
        label: "menuitems.dashboards.list.default",
        icon: "bx-home-circle",
        link: "/",
        nivel: 1,
    },

    {
        id: 2,
        label: "menuitems.dashboards.text",
        icon: "bx-home-circle",
        nivel: 100,
        subItems: [
            {
                id: 3,
                label: "menuitems.dashboards.list.default",
                link: "/",
                parentId: 2,
                exibir: true,
                nivel: 100,
            },
            {
                id: 4,
                label: "menuitems.dashboards.list.atendimento",
                link: "/dashboard/atendimento",
                parentId: 2,
                exibir: true,
                nivel: 100,
            },
            {
                id: 5,
                label: "menuitems.dashboards.list.analitico",
                link: "/dashboard/analitico",
                parentId: 2,
                exibir: true,
                nivel: 100,
            },
            {
                id: 6,
                label: "menuitems.dashboards.list.supervisao",
                link: "/dashboard/supervisao",
                parentId: 2,
                exibir: true,
                nivel: 100,
            },
            {
                id: 7,
                label: "menuitems.dashboards.list.acompanhamento",
                link: "/dashboard/acompanhamento",
                parentId: 2,
                exibir: true,
                nivel: 100,
            },
        ]
    },

    {
        id: 700,
        label: "menuitems.orcamentos.text",
        icon: "bx-rocket",
        nivel: 0,
        badge: {
            variant: "info",
            text: "menuitems.dashboards.badge"
        },
        subItems: [
            {
                id: 701,
                label: "menuitems.orcamentos.list.listar",
                link: "/orcamentos/list",
                parentId: 700,
                exibir: true,
                nivel: 0,
            },
            {
                id: 702,
                label: "menuitems.orcamentos.list.editar",
                link: "/orcamento/editar",
                parentId: 700,
                exibir: false,
                nivel: 0,
            },
            {
                id: 705,
                label: "menuitems.orcamentos.list.imprimir",
                link: "/orcamento/impressao",
                parentId: 700,
                exibir: false,
                nivel: 0,
            },
            {
                id: 706,
                label: "menuitems.orcamentos.list.relatorcto",
                link: "/orcamentos/relatorcto",
                parentId: 700,
                exibir: true,
                nivel: 0,
            },

        ]
    },

    {
        id: 100,
        label: "menuitems.pedidos.text",
        icon: "bx-cart",
        nivel: 0,
        subItems: [
            {
                id: 101,
                label: "menuitems.pedidos.list.listar",
                link: "/pedidos/list",
                parentId: 100,
                exibir: true,
                nivel: 0,
            },
            {
                id: 103,
                label: "menuitems.pedidos.list.detalhes",
                link: "/pedido/detalhe",
                parentId: 100,
                exibir: false,
                nivel: 0,
            },
            {
                id: 104,
                label: "menuitems.pedidos.list.impressao",
                link: "/pedido/impressao/1",
                parentId: 100,
                exibir: false,
                nivel: 0,
            },
            {
                id: 105,
                label: "menuitems.pedidos.list.importararquivo",
                link: "/pedido/importar",
                parentId: 400,
                exibir: false,
                nivel: 0,
            },


            {
                id: 106,
                label: "menuitems.pedidos.list.anymarketpeds",
                link: "/pedidos/anymarket",
                parentId: 100,
                exibir: true,
                nivel: 0,
            },
            {
                id: 107,
                label: "menuitems.pedidos.list.blingpeds",
                link: "/pedidos/bling",
                parentId: 100,
                exibir: true,
                nivel: 0,
            },
            {
                id: 116,
                label: "menuitems.pedidos.list.traypeds",
                link: "/pedidos/tray",
                parentId: 100,
                exibir: true,
                nivel: 0,
            },
            {
                id: 120,
                label: "menuitems.pedidos.list.tinypeds",
                link: "/pedidos/tiny",
                parentId: 100,
                exibir: true,
                nivel: 0,
            },
            {
                id: 108,
                label: "menuitems.pedidos.list.vindipeds",
                link: "/pedidos/vindi",
                parentId: 100,
                exibir: true,
                nivel: 0,
            },
            {
                id: 109,
                label: "menuitems.pedidos.list.mercadolivre",
                link: "/pedido/dashmeli",
                parentId: 100,
                exibir: true,
                nivel: 0,
            },
            {
                id: 110,
                label: "menuitems.pedidos.list.mercadolivrepeds",
                link: "/pedidos/listmeli",
                parentId: 100,
                exibir: true,
                nivel: 0,
            },
            {
                id: 111,
                label: "menuitems.pedidos.list.mercadolivreped",
                link: "/pedido/pedmeli",
                parentId: 100,
                exibir: false,
                nivel: 0,
            },
            {
                id: 112,
                label: "menuitems.pedidos.list.mercadolivreped",
                link: "/pedido/listmeli",
                parentId: 100,
                exibir: false,
                nivel: 0,
            },


            {
                id: 113,
                label: "menuitems.pedidos.list.pdvlist",
                link: "/movspdv/list",
                parentId: 100,
                exibir: true,
                nivel: 0,
            },
            {
                id: 114,
                label: "menuitems.pedidos.list.pdveditar",
                link: "/movpdv/editar",
                parentId: 100,
                exibir: false,
                nivel: 0,
            },
            {
                id: 115,
                label: "menuitems.pedidos.list.movshopeetrk",
                link: "/movsshopeetrk/list",
                parentId: 100,
                exibir: true,
                nivel: 0,
            },
            {
                id: 1160,
                label: "menuitems.pedidos.list.movshopeetrkelk",
                link: "/movsshopeeelk/list",
                parentId: 100,
                exibir: true,
                nivel: 0,
            },
            {
                id: 117,
                label: "menuitems.pedidos.list.movshopeefin",
                link: "/movshptrkfins/list",
                parentId: 100,
                exibir: false,
                nivel: 0,
            },
            {
                id: 118,
                label: "menuitems.pedidos.list.relatpeds",
                link: "/pedidos/relatpeds",
                parentId: 100,
                exibir: true,
                nivel: 0,
            },

        ]
    },

    {
        id: 1000,
        label: "menuitems.econocargo.text",
        icon: "bxs-truck",
        link: "/calendario",
        nivel: 0,
        subItems: [

            {
                id: 1001,
                label: "menuitems.dashboards.list.fretes",
                link: "/dashboard/fretes",
                parentId: 1000,
                exibir: true,
                nivel: 0,
            },


            {
                id: 1002,
                label: "menuitems.dashboards.list.transportadora",
                link: "/dashboard/transportador",
                parentId: 1000,
                exibir: true,
                nivel: 0,
            },
            {
                id: 1003,
                label: "menuitems.dashboards.list.transpestado",
                link: "/dashboard/transpestado",
                parentId: 1000,
                exibir: true,
                nivel: 0,
            },

            {
                id: 1004,
                label: "menuitems.dashboards.list.transpregiao",
                link: "/dashboard/transpregiao",
                parentId: 1000,
                exibir: true,
                nivel: 0,
            },
            // {
            //     id: 1005,
            //     label: "menuitems.dashboards.list.eficentrega",
            //     link: "/dashboard/mapaeficentr",
            //     parentId: 1000,
            //     exibir: true,
            //     nivel: 0,
            // },

            {
                id: 10050,
                label: "menuitems.econocargo.list.listarinterna",
                link: "/cotafrts/listinterna",
                parentId: 1000,
                exibir: false,
                nivel: 0,
            },
            {
                id: 1006,
                label: "menuitems.econocargo.list.listarexterna",
                link: "/cotafrts/listexterna",
                parentId: 1000,
                exibir: false,
                nivel: 0,
            },
            {
                id: 1007,
                label: "menuitems.econocargo.list.listar",
                link: "/cotafrts/listnova",
                parentId: 1000,
                exibir: true,
                nivel: 0,
            },


            {
                id: 1008,
                label: "menuitems.econocargo.list.editar",
                link: "/cotafrt/editar",
                parentId: 700,
                exibir: false,
                nivel: 0,
            },


            {
                id: 1026,
                label: "menuitems.econocargo.list.listardedicada",
                link: "/cotafrtdeds/listdedicada",
                parentId: 1000,
                exibir: true,
                nivel: 0,
            },
            {
                id: 1027,
                label: "menuitems.econocargo.list.editardedicada",
                link: "/cotafrtded/editarded",
                parentId: 700,
                exibir: false,
                nivel: 0,
            },


            {
                id: 1009,
                label: "menuitems.transportador.list.cte",
                link: "/movctes/listnova",
                parentId: 1000,
                exibir: true,
                nivel: 0,
            },
            {
                id: 1010,
                label: "menuitems.transportador.list.editarcte",
                link: "/movcte/editar",
                parentId: 1000,
                exibir: false,
                nivel: 0,
            },
            {
                id: 1011,
                label: "menuitems.transportador.list.importarcte",
                link: "/movcte/importar",
                parentId: 1000,
                exibir: false,
                nivel: 0,
            },

            {
                id: 1012,
                label: "menuitems.transportador.list.ctecotaassinc",
                link: "/movctecotassinc/list",
                parentId: 1000,
                exibir: false,
                nivel: 0,
            },

            {
                id: 1013,
                label: "menuitems.transportador.list.ctecompassinc",
                link: "/movctecompassinc/list",
                parentId: 1000,
                exibir: false,
                nivel: 0,
            },

            {
                id: 1014,
                label: "menuitems.transportador.list.ctecotacomps",
                link: "/movctecotacomps/list",
                parentId: 1000,
                exibir: false,
                nivel: 0,
            },

            {
                id: 10140,
                label: "menuitems.orcamentos.list.listarmov",
                link: "/movimentos/listnova",
                parentId: 1000,
                exibir: true,
                nivel: 0,
            },
            {
                id: 10141,
                label: "menuitems.orcamentos.list.listargrid",
                link: "/movimentos/listgrid",
                parentId: 1000,
                exibir: true,
                nivel: 0,
            },
            {
                id: 1015,
                label: "menuitems.orcamentos.list.listarmovnv",
                link: "/movimentos/listnv",
                parentId: 1000,
                exibir: true,
                nivel: 0,
            },
            {
                id: 1016,
                label: "menuitems.orcamentos.list.cotarmov",
                link: "/movimento/cotarinterno",
                parentId: 1000,
                exibir: false,
                nivel: 0,
            },

            {
                id: 1017,
                label: "menuitems.orcamentos.list.editarmov",
                link: "/movimento/editar",
                parentId: 1000,
                exibir: false,
                nivel: 0,
            },
            {
                id: 1018,
                label: "menuitems.orcamentos.list.impmov",
                link: "/movimento/importar",
                parentId: 1000,
                exibir: false,
                nivel: 0,
            },
            {
                id: 1019,
                label: "menuitems.econocargo.list.tracking",
                link: "/tracking/detalhe",
                parentId: 1000,
                exibir: false,
                nivel: 0,
            },
            {
                id: 1020,
                label: "menuitems.econocargo.list.apurafretes",
                link: "/movcte/apuracao",
                parentId: 1000,
                exibir: true,
                nivel: 0,
            },
            /* Menu Processamento desativado - sem uso
            {
                id: 1021,
                label: "menuitems.orcamentos.list.processamento",
                link: "/processamentos/list",
                parentId: 1000,
                exibir: true,
                nivel: 0,
            },
            */

            {
                id: 1022,
                label: "menuitems.econocargo.list.controleentrega",
                link: "/controleentregas/controle-entrega",
                parentId: 1000,
                exibir: true,
                nivel: 0,
            },

            {
                id: 1023,
                label: "menuitems.econocargo.list.movagendamento",
                link: "/entrega-alterada/prev-alterada",
                parentId: 1000,
                exibir: true,
                nivel: 0,
            },
            {
                id: 1024,
                label: "menuitems.econocargo.list.trackermsgs",
                link: "/trackermsgss/list",
                parentId: 1000,
                exibir: true,
                nivel: 0,
            },
            {
                id: 1025,
                label: "menuitems.econocargo.list.instwhats",
                link: "/instwhats/list",
                parentId: 1000,
                exibir: false,
                nivel: 0,
            },
            {
                id: 10260,
                label: "menuitems.econocargo.list.relatfrete",
                link: "/fretes/relatfrete",
                parentId: 1000,
                exibir: true,
                nivel: 0,
            },
            {
                id: 10261,
                label: "menuitems.econocargo.list.logisticareversa",
                link: "/fretes/logreversa",
                parentId: 1000,
                exibir: true,
                nivel: 0,
            },

        ]
    },

    {
        id: 130,
        label: "menuitems.clientes.text",
        icon: "bx bxs-user-detail",
        nivel: 0,
        subItems: [
            {
                id: 136,
                label: "menuitems.clientes.list.listar",
                link: "/clientes/listnova",
                parentId: 130,
                exibir: true,
                nivel: 0,
            },
            {
                id: 132,
                label: "menuitems.clientes.visitas",
                link: "/visitas/list",
                parentId: 130,
                exibir: true,
                nivel: 0,
            },
            {
                id: 133,
                label: "menuitems.clientes.mapas",
                link: "/mapas/list",
                parentId: 130,
                exibir: true,
                nivel: 0,
            },
            {
                id: 134,
                label: "menuitems.clientes.list.editar",
                link: "/cliente/editar",
                parentId: 130,
                exibir: false,
                nivel: 0,
            },
            {
                id: 135,
                label: "menuitems.clientes.list.detalhes",
                link: "/cliente/detalhe",
                parentId: 130,
                exibir: false,
                nivel: 0,
            },
            {
                id: 1360,
                label: "menuitems.clientes.list.pesquisa",
                link: "/clientes/pesquisa",
                parentId: 130,
                exibir: true,
                nivel: 0,
            },
            {
                id: 137,
                label: "menuitems.clientes.list.leads",
                link: "/clientes/leads",
                parentId: 130,
                exibir: true,
                nivel: 0,
            },
            {
                id: 138,
                label: "menuitems.clientes.list.comunicacao",
                link: "/clientes/comunicacao",
                parentId: 130,
                exibir: true,
                nivel: 0,
            },
            {
                id: 139,
                label: "menuitems.clientes.list.editarmsg",
                link: "/clientes/readmsg",
                parentId: 130,
                exibir: false,
                nivel: 0,
            },
            {
                id: 140,
                label: "menuitems.clientes.list.relatcrm",
                link: "/crm/relatcrm",
                parentId: 130,
                exibir: true,
                nivel: 0,
            },
            {
                id: 141,
                label: "menuitems.clientes.list.whatsapp",
                link: "/wsapi/whatsapp",
                parentId: 130,
                exibir: true,
                nivel: 0,
            },
            {
                id: 142,
                label: "menuitems.clientes.list.mensagenswa",
                link: "/wsapi/mensagens",
                parentId: 130,
                exibir: true,
                nivel: 0,
            },
            {
                id: 143,
                label: "menuitems.clientes.list.chamadoswa",
                link: "/crm/chamados-wsapi",
                parentId: 130,
                exibir: true,
                nivel: 0,
            },
        ]
    },


    /* Menu Transporte desativado - sem uso
    {
        id: 150,
        label: "menuitems.transportadores.text",
        icon: "bx bxs-plane",
        nivel: 0,
        subItems: [
            {
                id: 151,
                label: "menuitems.transportadores.list.listar",
                link: "/minutas/list",
                parentId: 150,
                exibir: true,
                nivel: 0,
            },
            {
                id: 152,
                label: "menuitems.transportadores.list.editar",
                link: "/minuta/editar",
                parentId: 150,
                exibir: false,
                nivel: 0,
            },

            {
                id: 153,
                label: "menuitems.transportadores.list.listarcte",
                link: "/movctesfiscal/list",
                parentId: 150,
                exibir: true,
                nivel: 0,
            },
            {
                id: 154,
                label: "menuitems.transportadores.list.editarcte",
                link: "/movctefiscal/editar",
                parentId: 150,
                exibir: false,
                nivel: 0,
            },
            {
                id: 155,
                label: "menuitems.servicos.list.mdfes",
                link: "/movmdfesfiscal/list",
                parentId: 150,
                exibir: true,
                nivel: 0,
            },
            {
                id: 156,
                label: "menuitems.servicos.list.editarmdfefiscal",
                link: "/movmdfefiscal/editar",
                parentId: 150,
                exibir: false,
                nivel: 0,
            },

            {
                id: 157,
                label: "menuitems.transportadores.list.listarveiculos",
                link: "/veiculos/list",
                parentId: 150,
                exibir: true,
                nivel: 0,
            },
            {
                id: 158,
                label: "menuitems.transportadores.list.editarveiculo",
                link: "/veiculo/editar",
                parentId: 150,
                exibir: false,
                nivel: 0,
            },

            {
                id: 159,
                label: "menuitems.transportadores.list.listarmarketplace",
                link: "/marketplace/list",
                parentId: 150,
                exibir: true,
                nivel: 0,
            },

        ]
    },
    */


    {
        id: 21,
        label: "menuitems.calendar.text",
        icon: "bx-calendar",
        link: "/calendario",
        nivel: 0,
    },


    {
        id: 22,
        label: "menuitems.administrativo.text",
        isTitle: true,
        nivel: 0,
    },
    {
        id: 230,
        label: "menuitems.produtos.text",
        icon: "bx bxs-dashboard",
        nivel: 0,
        subItems: [
            {
                id: 231,
                label: "menuitems.produtos.list.listar",
                link: "/produtos/list",
                parentId: 230,
                exibir: true,
                nivel: 0,
            },
            {
                id: 232,
                label: "menuitems.produtos.list.detalhes",
                link: "/produto/detalhe",
                parentId: 230,
                exibir: false,
                nivel: 0,
            },
            {
                id: 233,
                label: "menuitems.produtos.list.editar",
                link: "/produto/editar",
                parentId: 230,
                exibir: false,
                nivel: 0,
            },
            {
                id: 234,
                label: "menuitems.produtos.list.tabelas",
                link: "/tabprecos/list",
                parentId: 230,
                exibir: true,
                nivel: 0,
            },
            {
                id: 235,
                label: "menuitems.produtos.list.tabeditar",
                link: "/tabpreco/editar",
                parentId: 230,
                exibir: false,
                nivel: 0,
            },


            {
                id: 236,
                label: "menuitems.estoque.list.posicionamento",
                link: "/movcompras/posicionamento",
                parentId: 240,
                exibir: true,
                nivel: 0,
            },
            {
                id: 237,
                label: "menuitems.estoque.list.carregamento",
                link: "/movcompras/carregamento",
                parentId: 240,
                exibir: true,
                nivel: 0,
            },
            {
                id: 238,
                label: "menuitems.produtos.list.relatproduto",
                link: "/produtos/relatproduto",
                parentId: 230,
                exibir: true,
                nivel: 0,
            },

        ]
    },

    {
        id: 400,
        label: "menuitems.estoque.text",
        icon: "bx bxs-layer",
        nivel: 0,
        subItems: [



            {
                id: 406,
                label: "menuitems.estoque.list.produtos",
                link: "/produtos/listestoque",
                parentId: 400,
                exibir: true,
                nivel: 0,
            },


            {
                id: 407,
                label: "menuitems.estoque.list.monitoramento",
                link: "/movcompras/monitora",
                parentId: 400,
                exibir: true,
                nivel: 0,
            },

            {
                id: 408,
                label: "menuitems.estoque.list.importararquivo",
                link: "/movcompra/importar",
                parentId: 400,
                exibir: false,
                nivel: 0,
            },
            {
                id: 409,
                label: "menuitems.estoque.list.compras",
                link: "/movcompras/list",
                parentId: 400,
                exibir: true,
                nivel: 0,
            },
            {
                id: 410,
                label: "menuitems.estoque.list.editarcompra",
                link: "/movcompra/editar",
                parentId: 400,
                exibir: false,
                nivel: 0,
            },


            {
                id: 411,
                label: "menuitems.estoque.list.ajuste",
                link: "/movajustes/list",
                parentId: 400,
                exibir: true,
                nivel: 0,
            },
            {
                id: 412,
                label: "menuitems.estoque.list.editarajuste",
                link: "/movajuste/editar",
                parentId: 400,
                exibir: false,
                nivel: 0,
            },


            {
                id: 4120,
                label: "menuitems.estoque.list.devolucao",
                link: "/movdevols/list",
                parentId: 400,
                exibir: true,
                nivel: 0,
            },
            {
                id: 413,
                label: "menuitems.estoque.list.editardevolucao",
                link: "/movdevol/editar",
                parentId: 400,
                exibir: false,
                nivel: 0,
            },

            {
                id: 414,
                label: "menuitems.estoque.list.transf",
                link: "/movtransfs/list",
                parentId: 400,
                exibir: true,
                nivel: 0,
            },
            {
                id: 415,
                label: "menuitems.estoque.list.editartransf",
                link: "/movtransf/editar",
                parentId: 400,
                exibir: false,
                nivel: 0,
            },

            {
                id: 416,
                label: "menuitems.estoque.list.inventario",
                link: "/movinvents/list",
                parentId: 400,
                exibir: true,
                nivel: 0,
            },
            {
                id: 417,
                label: "menuitems.estoque.list.editarinventario",
                link: "/movinvent/editar",
                parentId: 400,
                exibir: false,
                nivel: 0,
            },
            {
                id: 418,
                label: "menuitems.estoque.list.relatestoque",
                link: "/estoque/relatestoque",
                parentId: 400,
                exibir: true,
                nivel: 0,
            },

        ]
    },


    {
        id: 1200,
        label: "menuitems.wms.text",
        icon: "bx bxs-box",
        nivel: 0,
        subItems: [
            {
                id: 1201,
                label: "menuitems.wms.list.wmsossaida",
                link: "/wmsossaida/list",
                parentId: 1200,
                exibir: true,
                nivel: 0,
            },
            {
                id: 1202,
                label: "menuitems.wms.list.wmsosentrada",
                link: "/wmsosentrada/list",
                parentId: 1200,
                exibir: true,
                nivel: 0,
            },
            {
                id: 1203,
                label: "menuitems.wms.list.editarwmsos",
                link: "/wmsos/editar",
                parentId: 1200,
                exibir: false,
                nivel: 0,
            },
            {
                id: 1204,
                label: "menuitems.wms.list.editarwmsosentr",
                link: "/wmsos/entradaeditarnova",
                parentId: 1200,
                exibir: false,
                nivel: 0,
            },
            {
                id: 1205,
                label: "menuitems.wms.list.editarwmsos",
                link: "/wmsos/saidaeditarnova",
                parentId: 1200,
                exibir: false,
                nivel: 0,
            },
            {
                id: 1206,
                label: "menuitems.wms.list.editarwmsosroma",
                link: "/wmsos/saidaromaeditar",
                parentId: 1200,
                exibir: false,
                nivel: 0,
            },
            {
                id: 1207,
                label: "menuitems.wms.list.enderecamento",
                link: "/enderecos/list",
                parentId: 300,
                exibir: true,
                nivel: 0,
            },
            {
                id: 1208,
                label: "menuitems.wms.list.romaneio",
                link: "/wmsromaneios/list",
                parentId: 1200,
                exibir: true,
                nivel: 0,
            },
            {
                id: 1209,
                label: "menuitems.wms.list.editarwmsrom",
                link: "/wmsromaneio/editar",
                parentId: 1200,
                exibir: false,
                nivel: 0,
            },
            {
                id: 1210,
                label: "menuitems.wms.list.expedirwmsrom",
                link: "/wmsromaneio/expedir",
                parentId: 1200,
                exibir: false,
                nivel: 0,
            },
            {
                id: 1211,
                label: "menuitems.wms.list.paletes",
                link: "/paletes/list",
                parentId: 1200,
                exibir: true,
                nivel: 0,
            },
            {
                id: 1212,
                label: "menuitems.administrativo.listimpressoras.listarimpressoras",
                link: "/impressoras/list",
                parentId: 1200,
                exibir: true,
                nivel: 100,
            },
            {
                id: 1213,
                label: "menuitems.wms.list.relatwms",
                link: "/wms/relatwms",
                parentId: 1200,
                exibir: true,
                nivel: 0,
            },
            {
                id: 1214,
                label: "menuitems.wms.list.roteirizador",
                link: "/roteirizador/list",
                parentId: 1200,
                exibir: true,
                nivel: 0,
            },

        ]
    },

    {
        id: 1300,
        label: "menuitems.coletor.text",
        icon: "bx bxs-box",
        nivel: 0,
        subItems: [
            {
                id: 1301,
                label: "menuitems.coletor.list.conferenciacoletor",
                link: "/coletor/conferenciacoletor/0",
                parentId: 1300,
                exibir: true,
                nivel: 0,
            },
            {
                id: 1302,
                label: "menuitems.coletor.list.inventariocoletor",
                link: "/coletor/inventariocoletor/0",
                parentId: 1300,
                exibir: true,
                nivel: 0,
            },
            {
                id: 1303,
                label: "menuitems.coletor.list.transferenciacoletor",
                link: "/coletor/transferenciacoletor/0",
                parentId: 1300,
                exibir: true,
                nivel: 0,
            },
            {
                id: 1304,
                label: "menuitems.coletor.list.recebimentocoletor",
                link: "/coletor/recebimentocoletor/0",
                parentId: 1300,
                exibir: true,
                nivel: 0,
            },
            {
                id: 1305,
                label: "menuitems.coletor.list.romaneiocoletor",
                link: "/coletor/romaneiocoletorlist",
                parentId: 1300,
                exibir: true,
                nivel: 0,
            },
        ]
    },


    {
        id: 900,
        label: "menuitems.servicos.text",
        icon: "bx bxs-group",
        nivel: 0,
        subItems: [

            {
                id: 901,
                label: "menuitems.servicos.list.listar",
                link: "/movservs/list",
                parentId: 900,
                exibir: true,
                nivel: 0,
            },
            {
                id: 902,
                label: "menuitems.servicos.list.editar",
                link: "/movserv/editar",
                parentId: 900,
                exibir: false,
                nivel: 0,
            },
            {
                id: 903,
                label: "menuitems.servicos.list.correiologrev",
                link: "/correioslogrev/list",
                parentId: 900,
                exibir: true,
                nivel: 0,
            },
            {
                id: 908,
                label: "menuitems.servicos.list.relatservico",
                link: "/servicos/relatservico",
                parentId: 900,
                exibir: true,
                nivel: 0,
            },

        ]
    },



    // {
    //     id: 200,
    //     label: "menuitems.transportador.text",
    //     icon: "bx bxs-truck",
    //     nivel: 0,
    //     subItems: [
    //         {
    //             id: 201,
    //             label: "menuitems.transportador.list.cte",
    //             link: "/movctes/list",
    //             parentId: 200,
    //             exibir: true,
    //             nivel: 0,
    //         },
    //
    //
    //         {
    //             id: 205,
    //             label: "menuitems.transportador.list.ctenova",
    //             link: "/movctes/listnova",
    //             parentId: 200,
    //             exibir: true,
    //             nivel: 0,
    //         },
    //
    //         {
    //             id: 203,
    //             label: "menuitems.transportador.list.editarcte",
    //             link: "/movcte/editar",
    //             parentId: 200,
    //             exibir: false,
    //             nivel: 0,
    //         },
    //         {
    //             id: 204,
    //             label: "menuitems.transportador.list.importarcte",
    //             link: "/movcte/importar",
    //             parentId: 200,
    //             exibir: false,
    //             nivel: 0,
    //         },
    //     ]
    // },


    {
        id: 260,
        label: "menuitems.cadastros.text",
        icon: "bx-receipt",
        nivel: 100,
        subItems: [

            {
                id: 276,
                label: "menuitems.servicos.list.gestaoprojeto",
                link: "/gestaoprojeto",
                parentId: 260,
                exibir: true,
                nivel: 100,
            },
            {
                id: 277,
                label: "menuitems.servicos.list.recursos",
                link: "/gpresources",
                parentId: 260,
                exibir: false,
                nivel: 100,
            },


            {
                id: 272,
                label: "menuitems.servicos.list.contratos",
                link: "/contratos/list",
                parentId: 260,
                exibir: true,
                nivel: 100,
            },
            {
                id: 275,
                label: "menuitems.servicos.list.editarcontrato",
                link: "/contrato/editar",
                parentId: 260,
                exibir: false,
                nivel: 100,
            },

            {
                id: 278,
                label: "menuitems.cadastros.list.categorias",
                link: "/categorias/list",
                parentId: 260,
                exibir: true,
                nivel: 100,
            },

            {
                id: 279,
                label: "menuitems.cadastros.list.categedit",
                link: "/categoria/editar",
                parentId: 260,
                exibir: false,
                nivel: 100,
            },

            {
                id: 280,
                label: "menuitems.cadastros.list.caixas",
                link: "/caixas/list",
                parentId: 260,
                exibir: true,
                nivel: 100,
            },

            {
                id: 281,
                label: "menuitems.cadastros.list.caixaedit",
                link: "/caixa/editar",
                parentId: 260,
                exibir: false,
                nivel: 100,
            },

            {
                id: 261,
                label: "menuitems.cadastros.list.condicoes",
                link: "/condicoes/list",
                parentId: 260,
                exibir: true,
                nivel: 100,
            },
            {
                id: 262,
                label: "menuitems.cadastros.list.formas",
                link: "/formas/list",
                parentId: 260,
                exibir: true,
                nivel: 100,
            },
            {
                id: 263,
                label: "menuitems.cadastros.list.pedtipo",
                link: "/tiposopera/list",
                parentId: 260,
                exibir: true,
                nivel: 100,
            },
            {
                id: 264,
                label: "menuitems.pedtipos.list.editar",
                link: "/tipoopera/editar",
                parentId: 260,
                exibir: false,
                nivel: 100,
            },
            {
                id: 265,
                label: "menuitems.cadastros.list.representantes",
                link: "/repres/list",
                parentId: 260,
                exibir: true,
                nivel: 100,
            },
            {
                id: 266,
                label: "menuitems.cadastros.list.projetos",
                link: "/projetos/list",
                parentId: 260,
                exibir: true,
                nivel: 100,
            },
            // {
            //     id: 267,
            //     label: "menuitems.cadastros.list.projetosnv",
            //     link: "/projetos/listnv",
            //     parentId: 260,
            //     exibir: true,
            //     nivel: 100,
            // },
            {
                id: 268,
                label: "menuitems.cadastros.list.projetodetalhe",
                link: "/projeto/detalhe",
                parentId: 260,
                exibir: false,
                nivel: 100,
            },
            {
                id: 269,
                label: "menuitems.cadastros.list.projetoedit",
                link: "/projeto/editar",
                parentId: 260,
                exibir: false,
                nivel: 100,
            },

            {
                id: 270,
                label: "menuitems.cadastros.list.mesas",
                link: "/mesas/list",
                parentId: 260,
                exibir: false,
                nivel: 100,
            },
            {
                id: 271,
                label: "menuitems.cadastros.list.mesadetalhe",
                link: "/mesa/detalhe",
                parentId: 260,
                exibir: false,
                nivel: 100,
            },
            {
                id: 2721,
                label: "menuitems.cadastros.list.mesaedit",
                link: "/mesa/editar",
                parentId: 260,
                exibir: false,
                nivel: 100,
            },

            {
                id: 273,
                label: "menuitems.cadastros.list.trackerevents",
                link: "/trackerevents/list",
                parentId: 260,
                exibir: true,
                nivel: 100,
            },

            {
                id: 274,
                label: "menuitems.cadastros.list.relatcadastro",
                link: "/cadastros/relatcadastro",
                parentId: 260,
                exibir: true,
                nivel: 100,
            },



        ]
    },

    {
        id: 310,
        label: "menuitems.financeiro.text",
        icon: "bx-money",
        nivel: 100,
        subItems: [
            /*{
                id: 311,
                label: "menuitems.financeiro.list.contacorrente",
                link: "/ccorrente/list",
                parentId: 310,
                exibir: true,
                nivel: 100,
            },*/
            {
                id: 324,
                label: "menuitems.financeiro.list.extratofinanc",
                link: "/extratofinanc/list",
                parentId: 310,
                exibir: true,
                nivel: 100,
            },
            /*{
                id: 312,
                label: "menuitems.financeiro.list.caixa",
                link: "/fincaixa/list",
                parentId: 310,
                exibir: true,
                nivel: 100,
            },*/
            /*{
                id: 323,
                label: "menuitems.financeiro.list.fluxocaixa",
                link: "/fluxocaixa/list",
                parentId: 310,
                exibir: true,
                nivel: 100,
            },*/
            {
                id: 313,
                label: "menuitems.financeiro.list.contaspagar",
                link: "/financeiros/contaspagar",
                parentId: 310,
                exibir: true,
                nivel: 100,
            },
            {
                id: 3220,
                label: "menuitems.financeiro.list.contaspagardetalhado",
                link: "/financeiros/contaspagardetalhado",
                parentId: 310,
                exibir: true,
                nivel: 100,
            },
            {
                id: 314,
                label: "menuitems.financeiro.list.editarcpagar",
                link: "/cpagar/editar",
                parentId: 310,
                exibir: false,
                nivel: 100,
            },
            {
                id: 315,
                label: "menuitems.financeiro.list.contasreceber",
                link: "/financeiros/contasreceber",
                parentId: 310,
                exibir: true,
                nivel: 100,
            },
            {
                id: 3221,
                label: "menuitems.financeiro.list.contasreceberdetalhado",
                link: "/financeiros/contasreceberdetalhado",
                parentId: 310,
                exibir: true,
                nivel: 100,
            },
            {
                id: 316,
                label: "menuitems.financeiro.list.editarcreceber",
                link: "/creceber/editar",
                parentId: 310,
                exibir: false,
                nivel: 100,
            },
            {
                id: 317,
                label: "menuitems.financeiro.list.ccorrentes",
                link: "/ccorrentes/list",
                parentId: 310,
                exibir: true,
                nivel: 100,
            },
            {
                id: 318,
                label: "menuitems.financeiro.list.comissoes",
                // link: "/financeiros/comissoes",
                link: "/comissoes/list",
                parentId: 310,
                exibir: true,
                nivel: 100,
            },

            {
                id: 3230,
                label: "menuitems.financeiro.list.comissoescalc",
                link: "/comissoes/calc",
                parentId: 310,
                exibir: true,
                nivel: 100,
            },

            {
                id: 319,
                label: "menuitems.financeiro.list.doccob",
                link: "/financeiros/doccobs",
                parentId: 310,
                exibir: true,
                nivel: 100,
            },
            {
                id: 320,
                label: "menuitems.financeiro.list.doccobeditar",
                link: "/doccob/editar",
                parentId: 310,
                exibir: false,
                nivel: 100,
            },
            {
                id: 321,
                label: "menuitems.financeiro.list.vouchers",
                link: "/financeiros/vouchers",
                parentId: 310,
                exibir: true,
                nivel: 100,
            },
            {
                id: 3222,
                label: "menuitems.financeiro.list.relatfinanc",
                link: "/financeiros/relatfinanc",
                parentId: 310,
                exibir: true,
                nivel: 100,
            },

            // {
            //     id: 134,
            //     label: "menuitems.clientes.list.editar",
            //     link: "/cliente/editar",
            //     parentId: 130,
            //     exibir: false,
            //     nivel: 0,
            // },
        ]
    },

    {
        id: 500,
        label: "menuitems.fiscal.text",
        icon: "bx bx-book-content",
        nivel: 100,
        subItems: [
            {
                id: 501,
                label: "menuitems.fiscal.list.naturezas",
                link: "/naturezas/list",
                parentId: 500,
                exibir: true,
                nivel: 100,
            },
            {
                id: 502,
                label: "menuitems.fiscal.list.editar",
                link: "/natureza/editar",
                parentId: 500,
                exibir: false,
                nivel: 100,
            },
            {
                id: 503,
                label: "menuitems.fiscal.list.cfop",
                link: "/cfop/list",
                parentId: 500,
                exibir: true,
                nivel: 100,
            },
            {
                id: 504,
                label: "menuitems.fiscal.list.notasfiscais",
                link: "/notasinuteis/list",
                parentId: 500,
                exibir: true,
                nivel: 100,
            },
            {
                id: 505,
                label: "menuitems.fiscal.list.estados",
                link: "/estados/list",
                parentId: 500,
                exibir: true,
                nivel: 100,
            },
            {
                id: 506,
                label: "menuitems.fiscal.list.relatfiscal",
                link: "/fiscal/relatfiscal",
                parentId: 500,
                exibir: true,
                nivel: 100,
            },
        ]
    },




    {
        id: 480,
        label: "menuitems.administrativo.text",
        icon: "bx-shield-alt-2",
        isAdmin: true,
        nivel: 100,
        subItems: [
            {
                id: 481,
                label: "menuitems.administrativo.listusers.listarusers",
                link: "/usuarios/list",
                parentId: 480,
                exibir: true,
                nivel: 100,
            },
            {
                id: 482,
                label: "menuitems.administrativo.listusers.detalhesuser",
                link: "/usuario/detalhe",
                parentId: 480,
                exibir: false,
                nivel: 100,
            },
            {
                id: 483,
                label: "menuitems.administrativo.listusers.editaruser",
                link: "/usuario/editar",
                parentId: 480,
                exibir: false,
                nivel: 100,
            },

            {
                id: 484,
                label: "menuitems.administrativo.listempresas.listarempresas",
                link: "/empresas/list",
                parentId: 480,
                exibir: true,
                nivel: 100,
            },
            {
                id: 485,
                label: "menuitems.administrativo.listempresas.editarempresa",
                link: "/empresa/editar",
                parentId: 480,
                exibir: false,
                nivel: 100,
            },

            {
                id: 487,
                label: "menuitems.administrativo.listimpressoras.listarimpressoras",
                link: "/impressoras/list",
                parentId: 480,
                exibir: true,
                nivel: 100,
            },

            {
                id: 488,
                label: "menuitems.administrativo.ocorenfinal",
                link: "/ocorfinais/list",
                parentId: 480,
                exibir: true,
                nivel: 100,
            },

            {
                id: 489,
                label: "menuitems.administrativo.fretecota",
                link: "/fretecotas/list",
                parentId: 480,
                exibir: true,
                nivel: 100,
            },

            {
                id: 490,
                label: "menuitems.administrativo.ocorrencias",
                link: "/ocorrencias/list",
                parentId: 480,
                exibir: true,
                nivel: 100,
            },
            {
                id: 491,
                label: "menuitems.administrativo.monitoramentotracking",
                link: "/tracking/monitoramento",
                parentId: 480,
                exibir: true,
                nivel: 100,
            },
            {
                id: 492,
                label: "menuitems.econocargo.list.cotacaofretes",
                link: "/cotacaofretesbase/list",
                parentId: 1000,
                exibir: true,
                nivel: 0,
            },
            {
                id: 493,
                label: "menuitems.econocargo.list.cotacaofretestrttda",
                link: "/cotacaofretesbase/editar",
                parentId: 130,
                exibir: false,
                nivel: 0,
            },
            {
                id: 494,
                label: "menuitems.econocargo.list.cotacaofretestrttda",
                link: "/cotacaofretesbasetrttda/list",
                parentId: 1000,
                exibir: false,
                nivel: 0,
            },
            {
                id: 495,
                label: "menuitems.econocargo.list.cotacaofretestde",
                link: "/cotacaofretesbasetde/list",
                parentId: 1000,
                exibir: false,
                nivel: 0,
            },
            {
                id: 496,
                label: "menuitems.econocargo.list.cotacaofretestde",
                link: "/cotacaofretesbasetde/editar",
                parentId: 130,
                exibir: false,
                nivel: 0,
            },
            {
                id: 497,
                label: "menuitems.econocargo.list.cotacaofretesbasetab",
                link: "/cotacaofretesbasetab/editar",
                parentId: 130,
                exibir: false,
                nivel: 0,
            },



            {
                id: 40001,
                label: "menuitems.econocargo.list.cotacaofreteselk",
                link: "/cotacaofretesbaseelk/list",
                parentId: 1000,
                exibir: true,
                nivel: 0,
            },
            {
                id: 40002,
                label: "menuitems.econocargo.list.cotacaofretesbasetab",
                link: "/cotacaofretesbasetabelk/editar",
                parentId: 1000,
                exibir: false,
                nivel: 0,
            },



            {
                id: 4850,
                label: "menuitems.administrativo.forminbound",
                link: "/forminbound/editar",
                parentId: 130,
                exibir: true,
                nivel: 0,
            },

            {
                id: 486,
                label: "menuitems.administrativo.relatadmin",
                link: "/relatsadm/relatadmin",
                parentId: 480,
                exibir: true,
                nivel: 100,
            },

            {
                id: 487,
                label: "menuitems.administrativo.releasestimeline",
                link: "/administrativo/releases-timeline",
                parentId: 480,
                exibir: true,
                nivel: 100,
            },



        ]
    },

    {
        id: 40,
        label: "menuitems.auxiliar.text",
        isTitle: true,
        nivel: 0,
    },
    {
        id: 1100,
        label: "menuitems.atendimento.atendimento",
        icon: "bx-message-rounded-dots",
        nivel: 100,
        badge: {
            variant: "success",
            text: "menuitems.novo.text"
        },
        subItems: [
            {
                id: 1101,
                label: 'menuitems.atendimento.textprod',
                link: '/atendimentos/listprod',
                parentId: 1100,
                exibir: true,
                nivel: 100,
            },
            {
                id: 1102,
                label: 'menuitems.atendimento.editarchamdo',
                link: '/atendimento/detalhes',
                parentId: 1100,
                exibir: false,
                nivel: 100,
            },
            {
                id: 1103,
                label: 'menuitems.atendimento.text',
                link: '/atendimentos/list',
                parentId: 1100,
                exibir: true,
                nivel: 100,
            },
            {
                id: 1104,
                label: 'menuitems.atendimento.chat',
                link: '/atendimentos/chat',
                parentId: 1100,
                exibir: true,
                nivel: 100,
            },
            {
                id: 1105,
                label: 'menuitems.atendimento.configuracao',
                link: '/atendimentos/config',
                parentId: 1100,
                exibir: true,
                nivel: 100,
            },
            {
                id: 1106,
                label: 'menuitems.atendimento.mensagens',
                link: '/atendimento/mensagens',
                parentId: 1100,
                exibir: true,
                nivel: 100,
            }
        ]


    },


    {
        id: 600,
        label: "menuitems.social.redessociais",
        icon: "bx bxl-instagram",
        nivel: 100,
        subItems: [
            {
                id: 601,
                label: "menuitems.social.posts",
                link: "/postagens/list",
                parentId: 600,
                exibir: true,
                nivel: 100,
            },
            {
                id: 602,
                label: "menuitems.social.detalhe",
                link: "/postagem/detalhe/1",
                parentId: 600,
                exibir: false,
                nivel: 100,
            },
            {
                id: 603,
                label: "menuitems.social.addpost",
                link: "/postagem/editar/0",
                parentId: 600,
                exibir: true,
                nivel: 100,
            },
            {
                id: 604,
                label: "menuitems.social.recfacial",
                link: "/recfacial/list",
                parentId: 600,
                exibir: true,
                nivel: 100,
            },
        ]
    },

    {
        id: 42,
        label: "menuitems.notificacoes.text",
        icon: "bx-task",
        nivel: 0,
        badge: {
            variant: "warning",
            text: "menuitems.notificacoes.badge"
        },
        link: "/notificacoes/list",
    },
    {
        id: 43,
        label: "menuitems.filemanager.text",
        link: "/arquivos",
        icon: "bx-file",
        nivel: 0,
    },
    {
        id: 50,
        label: "menuitems.logs.text",
        icon: "bx-file-blank",
        nivel: 0,
        subItems: [
            {
                id: 51,
                label: "menuitems.logs.list.logdispemail",
                link: "/logdispemail",
                parentId: 50,
                exibir: true,
                nivel: 0,
            },
            ]
    },
    {
        id: 44,
        label: "menuitems.suporte.text",
        icon: "bx-help-circle",
        nivel: 0,
        subItems: [
            {
                id: 45,
                label: 'menuitems.suporte.list.material',
                link: '/suporte/material',
                parentId: 44,
                exibir: true,
                nivel: 0,
            },
            {
                id: 46,
                label: 'menuitems.suporte.list.postagem',
                link: '/suporte/postagem',
                parentId: 44,
                exibir: false,
                nivel: 0,
            },
            {
                id: 47,
                label: 'menuitems.suporte.list.pesquisa',
                link: '/suporte/pesquisa',
                parentId: 44,
                exibir: false,
                nivel: 0,
            },
            {
                id: 48,
                label: 'menuitems.suporte.list.chamados',
                link: '/suporte/chamados',
                parentId: 44,
                exibir: true,
                nivel: 0,
            },
            {
                id: 49,
                label: 'menuitems.suporte.list.faleconosco',
                link: '/suporte/chamados',
                parentId: 44,
                exibir: true,
                nivel: 0,
            },

        ]
    },


    {
        id: 450,
        label: "menuitems.tms.text",
        icon: "bxs-truck",
        exibir: false,
        nivel: 0,
        subItems: [
            {
                id: 451,
                label: 'menuitems.tms.list.tms_cotacoes',
                isTitle: true,
                parentId: 450,
                exibir: true,
                nivel: 0,
                subItems: [
                    {
                        id: 452,
                        label: 'menuitems.tms.list.cotacoes_frete',
                        link: "/cotafrts/listnova",
                        parentId: 450,
                        exibir: true,
                        nivel: 0,
                    },
                    {
                        id: 453,
                        label: "menuitems.tms.list.editarcotacoes_frete",
                        link: "/cotafrt/editar",
                        parentId: 450,
                        exibir: false,
                        nivel: 0,
                    },
                    {
                        id: 454,
                        label: 'menuitems.tms.list.cotacoes_dedicadas',
                        link: "/cotafrtdeds/listdedicada",
                        parentId: 450,
                        exibir: true,
                        nivel: 0,
                    },
                    {
                        id: 455,
                        label: "menuitems.tms.list.editarcotacoes_dedicadas",
                        link: "/cotafrtded/editarded",
                        parentId: 450,
                        exibir: false,
                        nivel: 0,
                    },
                    {
                        id: 456,
                        label: 'menuitems.tms.list.tabela_frete',
                        link: "/cotacaofretesbase/list",
                        parentId: 450,
                        exibir: true,
                        nivel: 0,
                    },
                    {
                        id: 457,
                        label: 'menuitems.tms.list.tabela_frete_elk',
                        link: "/cotacaofretesbaseelk/list",
                        parentId: 450,
                        exibir: true,
                        nivel: 0,
                    },
                ]
            },
            {
                id: 460,
                label: 'menuitems.tms.list.tms_controle',
                isTitle: true,
                parentId: 450,
                exibir: true,
                nivel: 0,
                subItems: [
                    {
                        id: 461,
                        label: 'menuitems.tms.list.consulta_ctes',
                        link: "/movctes/listnova",
                        parentId: 450,
                        exibir: true,
                        nivel: 0,
                    },
                    {
                        id: 462,
                        label: 'menuitems.tms.list.consulta_nfes',
                        link: "/movimentos/listnova",
                        parentId: 450,
                        exibir: true,
                        nivel: 0,
                    },
                    {
                        id: 463,
                        label: 'menuitems.tms.list.processamento_frete',
                        link: "/processamentos/list",
                        parentId: 450,
                        exibir: true,
                        nivel: 0,
                    },
                    {
                        id: 464,
                        label: 'menuitems.tms.list.controle_entrega',
                        link: "/controleentregas/controle-entrega",
                        parentId: 450,
                        exibir: true,
                        nivel: 0,
                    },
                    {
                        id: 465,
                        label: 'menuitems.tms.list.relatorios_frete',
                        link: "/fretes/relatfrete",
                        parentId: 450,
                        exibir: true,
                        nivel: 0,
                    },
                ]
            },
            {
                id: 470,
                label: 'menuitems.tms.list.tms_newdashboard',
                isTitle: true,
                parentId: 450,
                exibir: true,
                nivel: 0,
                subItems: [
                    {
                        id: 471,
                        label: 'menuitems.tms.list.dash_fretegeral',
                        link: "/dashboard/fretes",
                        parentId: 450,
                        exibir: true,
                        nivel: 0,
                    },
                    {
                        id: 472,
                        label: 'menuitems.tms.list.dash_fretetransp',
                        link: "/dashboard/transportador",
                        parentId: 450,
                        exibir: true,
                        nivel: 0,
                    },
                    {
                        id: 473,
                        label: 'menuitems.tms.list.dash_freteestado',
                        link: "/dashboard/transpestado",
                        parentId: 450,
                        exibir: true,
                        nivel: 0,
                    },
                    {
                        id: 474,
                        label: 'menuitems.tms.list.dash_freteregiao',
                        link: "/dashboard/transpregiao",
                        parentId: 450,
                        exibir: true,
                        nivel: 0,
                    },
                ]
            },
            {
                id: 4800,
                label: 'menuitems.tms.list.integracoes',
                isTitle: true,
                parentId: 450,
                exibir: true,
                nivel: 0,
                subItems: [
                    {
                        id: 4810,
                        label: 'geral',
                        link: "/integracoes/geral",
                        parentId: 450,
                        exibir: true,
                        nivel: 0,
                    },
                ]
            },

        ]
    },


    {
        id: 550,
        label: "menuitems.controle.text",
        icon: "bxs-layer",
        exibir: false,
        nivel: 0,
        subItems: [
            {
                id: 551,
                label: 'menuitems.controle.list.consultacte',
                link: "/movctes/listnova",
                parentId: 550,
                exibir: true,
                nivel: 0,
            },
            {
                id: 552,
                label: 'menuitems.controle.list.consultanfe',
                link: "/movimentos/listnova",
                parentId: 550,
                exibir: true,
                nivel: 0,
            },
            {
                id: 553,
                label: 'menuitems.controle.list.processamentofretes',
                link: "/dashboard/transpregiao",
                parentId: 550,
                exibir: true,
                nivel: 0,
            },
            {
                id: 554,
                label: 'menuitems.controle.list.controleentregas',
                link: "/cotafrts/listnova",
                parentId: 550,
                exibir: true,
                nivel: 0,
            },
            {
                id: 555,
                label: "menuitems.controle.list.relatoriofretes",
                link: "/cotafrt/editar",
                parentId: 550,
                exibir: false,
                nivel: 0,
            },
            {
                id: 556,
                label: 'menuitems.controle.list.tabelasfrete',
                link: "/cotafrtdeds/listdedicada",
                parentId: 550,
                exibir: true,
                nivel: 0,
            },

        ]
    },


    {
        id: 650,
        label: "menuitems.integracoes.text",
        icon: "bx-globe",
        exibir: false,
        nivel: 0,
        subItems: [
            {
                id: 651,
                label: 'menuitems.integracoes.list.transportadoras',
                link: "/transportadoras/list",
                parentId: 650,
                exibir: true,
                nivel: 0
            }
        ]
    },


    {
        id: 750,
        label: "menuitems.geral.text",
        icon: "bx-list-ul",
        exibir: false,
        nivel: 0,
        subItems: [
            {
                id: 751,
                label: 'menuitems.geral.list.transportadoras',
                link: "/transportadoras/list",
                parentId: 750,
                exibir: true,
                nivel: 0
            }
        ]
    },

    {
        id: 850,
        label: "menuitems.configuracoes.text",
        icon: "bx-cog",
        exibir: false,
        nivel: 0,
        subItems: [
            {
                id: 851,
                label: "menuitems.configuracoes.listusers.listarusers",
                link: "/usuarios/list",
                parentId: 850,
                exibir: true,
                nivel: 0,
            },
            {
                id: 852,
                label: "menuitems.configuracoes.listusers.detalhesuser",
                link: "/usuario/detalhe",
                parentId: 850,
                exibir: false,
                nivel: 0,
            },
            {
                id: 853,
                label: "menuitems.configuracoes.listusers.editaruser",
                link: "/usuario/editar",
                parentId: 850,
                exibir: false,
                nivel: 0,
            },
            {
                id: 854,
                label: "menuitems.configuracoes.listempresas.listarempresas",
                link: "/empresas/list",
                parentId: 850,
                exibir: true,
                nivel: 0,
            },
            {
                id: 855,
                label: "menuitems.configuracoes.listempresas.editarempresa",
                link: "/empresa/editar",
                parentId: 850,
                exibir: false,
                nivel: 0,
            },

            {
                id: 856,
                label: "menuitems.configuracoes.listimpressoras.listarimpressoras",
                link: "/impressoras/list",
                parentId: 850,
                exibir: true,
                nivel: 0,
            },

            {
                id: 857,
                label: "menuitems.configuracoes.list.meuperfil",
                link: "/usuario/perfil/:id",
                parentId: 850,
                exibir: true,
                nivel: 0,
            },

            {
                id: 858,
                label: "menuitems.configuracoes.list.cadastrosgerais",
                link: "/clientes/listnova",
                parentId: 850,
                exibir: true,
                nivel: 0,
            },
        ]
    },

];
